import React from 'react';
import { ReactComponent as Logo } from './logo.svg';

const SiteLogo = () => (
  <div className='logo-container'>
    <Logo className='logo-svg' />
  </div>
);

export default SiteLogo;
